












import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { TrackFieldsLabels, TrackFields } from '@/constants'
import { IColumnDef } from '@/interfaces/ag-grid'
import { Track } from '@/classes/track'
import { TRANSFORMERS, TRANSFORMER, ITransformerSettings, getTransformationTargetFields } from '@/helpers/transformer'
import { colorCellRenderer } from '@/helpers/ag-grid/cellRenderer'
import { FieldTypes } from '@/helpers/filter-rules'

@Component({
  components: {
    ReorderTable: require('@/components/ReorderTable').default
  }
})
export default class Grid extends Vue {
  @Prop()
  settings: ITransformerSettings

  @Prop()
  transformer: TRANSFORMERS | null

  selectedTracks: Track[] = []

  columnDefs: IColumnDef[] = []
  debounceTimeout: any = null

  get tracks(): Track[] {
    return this.$store.getters['library/selectedTracks']
  }

  valueGetter(v: { data: Track }, index: number) {
    if (!this.transformer) return '-'

    const value = TRANSFORMER[this.transformer].transformer(v.data, this.settings)

    if (Array.isArray(value)) {
      return value[index]
    } else {
      return value
    }
  }

  generateColumnDefs() {
    if (!this.transformer) return

    if (TRANSFORMER[this.transformer].targetField) {
      const colDef: IColumnDef = {
        field: TRANSFORMER[this.transformer].targetField as TrackFields
      }

      if (colDef.field === TrackFields.Color) {
        colDef.cellRenderer = colorCellRenderer
      }

      this.columnDefs.push(colDef)
    } else {
      this.columnDefs = TRANSFORMER[this.transformer].fields
        .map((f, i) => {
          if (f.type !== FieldTypes.Field || f.isTargetField) return null

          const colDef: IColumnDef = {
            field: this.settings.values[i]
          }

          if (colDef.field === TrackFields.Color) {
            colDef.cellRenderer = colorCellRenderer
          }

          return colDef
        })
        .filter(f => f !== null) as IColumnDef[]
    }

    const targetFields = getTransformationTargetFields(this.transformer, this.settings)

    for (let i = 0; i < targetFields.length; i++) {
      const targetField = targetFields[i]

      const fieldLabel: string = TrackFieldsLabels[targetField] || targetField

      if (fieldLabel) {
        const field: string = 'New ' + fieldLabel

        const newFieldColDef: IColumnDef = {
          field,
          valueGetter: (v: any) => this.valueGetter(v, i)
        }

        if (targetField === TrackFields.Color) {
          newFieldColDef.cellRenderer = colorCellRenderer
        }

        this.columnDefs.push(newFieldColDef)
      }
    }

    if (!this.columnDefs.some(x => x.field === TrackFields.Title)) {
      this.columnDefs.unshift({
        field: TrackFields.Title
      })
    }
  }

  created() {
    this.generateColumnDefs()
  }

  @Watch('selectedTracks')
  watchSelectedTracks() {
    this.$emit('update:selectedTracks', this.selectedTracks)
  }

  @Watch('settings', { deep: true })
  watchFields() {
    clearTimeout(this.debounceTimeout)

    this.debounceTimeout = setTimeout(() => {
      this.generateColumnDefs()
    }, 1000)
  }
}
